<div
  class="card batch-commands-card"
  *appIsGranted="['PACKETS_COMMANDS_BATCH', 'PACKETS_COMMANDS_BATCH', 'READ']"
>
  <div class="card-body">
    <h6 class="card-title">Comandos em lote</h6>

    <div class="row g-3">
      <div class="col-md-3">
        <label class="form-label">Nome do comando em lote</label>
        <input
          type="text"
          class="form-control"
          placeholder="Ex: Bloqueio - Frota SP"
          [(ngModel)]="nomeComando"
        />

        <div class="mt-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="abrirModalNovoComando(modalNovoComando)"
          >
            Adicionar comando
          </button>
        </div>
        <div class="mt-1" *ngIf="comandoSelecionadoNome">
          <span class="badge bg-primary">Comando: {{ comandoSelecionadoNome }}</span>
        </div>
      </div>

      <div class="col-md-3">
        <label class="form-label d-block">Enviar comandos para:</label>

        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="envioSeriais"
            [checked]="envioPara === 'seriais'"
            (change)="selecionarEnvioPara('seriais')"
          />
          <label class="form-check-label" for="envioSeriais">Seriais</label>
        </div>

        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="envioEquipamento"
            [checked]="envioPara === 'equipamento'"
            (change)="selecionarEnvioPara('equipamento')"
          />
          <label class="form-check-label" for="envioEquipamento"
            >Equipamento</label
          >
        </div>
      </div>

      <div class="col-md-6" *ngIf="envioPara === 'seriais'">
        <label class="form-label">Seriais</label>
        <textarea
          class="form-control"
          rows="2"
          placeholder="205502151; 205502152; ..."
          [(ngModel)]="seriais"
        ></textarea>
        <small class="form-text text-muted"
          >Separe os seriais utilizando ";"</small
        >
      </div>

      <ng-container *ngIf="envioPara === 'equipamento'">
        <div class="col-md-3">
          <label class="form-label">Equipamento</label>
          <ng-select
            class="w-100"
            placeholder="Selecione um equipamento"
            [items]="equipamentos"
            [loading]="carregandoEquipamentos"
            [ngModel]="equipamentoSelecionado"
            (ngModelChange)="onEquipamentoChange($event)"
          >
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Firmware</label>
          <ng-select
            class="w-100"
            placeholder="Selecione um firmware"
            [items]="firmwares"
            [loading]="carregandoFirmwares"
            [disabled]="!equipamentoSelecionado"
            [(ngModel)]="firmwareSelecionado"
          >
          </ng-select>
        </div>
      </ng-container>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-12">
        <label class="form-label d-block">Agendamento de envio</label>

        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            id="agendamentoQualquerMomento"
            name="agendamentoTipo"
            [checked]="agendamentoTipo === 'qualquerMomento'"
            (change)="selecionarAgendamentoTipo('qualquerMomento')"
          />
          <label class="form-check-label" for="agendamentoQualquerMomento"
            >Executar a qualquer momento</label
          >
        </div>

        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            id="agendamentoEspecifico"
            name="agendamentoTipo"
            [checked]="agendamentoTipo === 'especifico'"
            (change)="selecionarAgendamentoTipo('especifico')"
          />
          <label class="form-check-label" for="agendamentoEspecifico"
            >Agendar horários específicos</label
          >
        </div>
      </div>

      <ng-container *ngIf="agendamentoTipo === 'especifico'">
        <div class="col-md-3">
          <label class="form-label">Dia da semana</label>
          <select class="form-select" [(ngModel)]="novoAgendamentoDia">
            <option [ngValue]="null">Selecione...</option>
            <option *ngFor="let dia of diasSemanaOptions" [ngValue]="dia.value">
              {{ dia.label }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">Das</label>
          <input
            type="time"
            class="form-control"
            [(ngModel)]="novoAgendamentoHoraInicio"
          />
        </div>
        <div class="col-md-2">
          <label class="form-label">Às</label>
          <input
            type="time"
            class="form-control"
            [(ngModel)]="novoAgendamentoHoraFim"
          />
        </div>
        <div class="col-md-2 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            (click)="adicionarAgendamento()"
          >
            Adicionar horário
          </button>
        </div>

        <div class="col-12" *ngIf="erroAgendamento">
          <p class="text-danger mb-0">{{ erroAgendamento }}</p>
        </div>

        <div class="col-12" *ngIf="agendamentos.length > 0">
          <ul class="list-group">
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              *ngFor="let agendamento of agendamentos; let i = index"
            >
              {{ labelDiaSemana(agendamento.diaSemana) }} das
              {{ agendamento.horaInicio }} às {{ agendamento.horaFim }}
              <button
                type="button"
                class="btn btn-sm btn-outline-danger"
                (click)="removerAgendamento(i)"
              >
                Remover
              </button>
            </li>
          </ul>
        </div>
      </ng-container>
    </div>

    <div class="row mt-3 align-items-center">
      <div class="col-md-8">
        <p class="text-danger mb-0" *ngIf="mensagemErro">
          {{ mensagemErro }}
        </p>
      </div>
      <div class="col-md-4 text-end">
        <button
          type="button"
          class="btn btn-outline-secondary me-2"
          [disabled]="salvando"
          (click)="limparFormulario()"
        >
          Limpar
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="salvando"
          (click)="cadastrar()"
        >
          Cadastrar
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="card batch-commands-list-card"
  *appIsGranted="['PACKETS_COMMANDS_BATCH', 'PACKETS_COMMANDS_BATCH', 'READ']"
>
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <h6 class="card-title mb-0">Comandos em lote enviados</h6>

      <div class="d-flex align-items-center refresh-timer-widget">
        <div ngbDropdown class="d-inline-block" container="body">
          <button
            type="button"
            class="btn btn-dark btn-sm refresh-timer-display"
            id="refreshIntervalDropdown"
            ngbDropdownToggle
            ngbTooltip="Clique para alterar o intervalo de atualização"
          >
            {{ tempoRestanteAtualizacaoFormatado }}
          </button>
          <div ngbDropdownMenu aria-labelledby="refreshIntervalDropdown">
            <button
              type="button"
              ngbDropdownItem
              *ngFor="let opcao of intervalosAtualizacao"
              [class.active]="intervaloAtualizacaoSegundos === opcao.segundos"
              (click)="selecionarIntervaloAtualizacao(opcao.segundos)"
            >
              {{ opcao.label }}
            </button>
          </div>
        </div>

        <button
          type="button"
          class="btn btn-outline-secondary btn-sm ms-2"
          [ngbTooltip]="timerAtualizacaoAtivo ? 'Pausar atualização automática' : 'Retomar atualização automática'"
          (click)="alternarTimerAtualizacao()"
        >
          <i-feather [name]="timerAtualizacaoAtivo ? 'square' : 'play'" class="icon-sm"></i-feather>
        </button>

        <button
          type="button"
          class="btn btn-outline-secondary btn-sm ms-2"
          ngbTooltip="Atualizar agora"
          [disabled]="carregandoLista"
          (click)="atualizarListaAgora()"
        >
          <i-feather name="refresh-cw" class="icon-sm"></i-feather>
        </button>
      </div>
    </div>

    <div class="row mb-3 align-items-end">
      <div class="col-md-2">
        <label class="form-label">Nome</label>
        <input
          type="text"
          class="form-control"
          placeholder="Nome"
          [(ngModel)]="filtroNome"
        />
      </div>
      <div class="col-md-2">
        <label class="form-label">Data Inicial</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filtroDataInicial"
        />
      </div>
      <div class="col-md-2">
        <label class="form-label">Data Final</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filtroDataFinal"
        />
      </div>
      <div class="col-md-2">
        <label class="form-label">Comando</label>
        <select class="form-select" [(ngModel)]="filtroIdComando">
          <option [ngValue]="-1">Todos</option>
          <option *ngFor="let command of commandInfoType" [ngValue]="command.comandoId">
            {{ command.nome }}
          </option>
        </select>
      </div>
      <div class="col-md-1">
        <label class="form-label">Status</label>
        <select class="form-select" [(ngModel)]="filtroStatus">
          <option value="">Todos</option>
          <option *ngFor="let status of statusOptions" [value]="status">
            {{ status }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Serial</label>
        <input
          type="text"
          class="form-control"
          placeholder="Serial"
          [(ngModel)]="filtroSerial"
        />
      </div>
      <div class="col-md-1">
        <button
          type="button"
          class="btn btn-outline-primary w-100"
          [disabled]="carregandoLista"
          (click)="filtrar()"
        >
          Filtrar
        </button>
      </div>
    </div>

    <p class="text-danger" *ngIf="filtroErro">{{ filtroErro }}</p>

    <div class="table-responsive">
      <table class="table table-bordered table-sm table-hover">
        <thead class="table-light">
          <tr>
            <th class="text-center">Id</th>
            <th class="text-center">Nome</th>
            <th class="text-center">Comando</th>
            <th class="text-center">Status</th>
            <th class="text-center">Usuário</th>
            <th class="text-center">Data Envio</th>
            <th class="text-center">Total</th>
            <th class="text-center">% Enviado</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of batchCommands">
            <td class="text-center">{{ item.id }}</td>
            <td class="text-center">{{ item.nome }}</td>
            <td class="text-center">{{ item.comando.nome }}</td>
            <td class="text-center">{{ item.status }}</td>
            <td class="text-center">{{ item.userName }}</td>
            <!-- formatar createTime de milis para dd/mm/yyyy hh:mm:ss -->
            <td class="text-center">{{ item.createTime | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="text-center">{{ item.quantidade }}</td>
            <td class="text-center">{{ item.percentualEnviado }}%</td>
            <td class="text-center">
              <i-feather
                ngbTooltip="Detalhar"
                name="eye"
                style="color: #2c7be5; cursor: pointer"
                (click)="abrirModalDetalhes(item, modalDetalhesComando)"
              ></i-feather>
              <i-feather
                ngbTooltip="Exportar CSV"
                name="download"
                [style.color]="exportandoCsv ? '#c9c9c9' : '#2c7be5'"
                [style.cursor]="exportandoCsv ? 'not-allowed' : 'pointer'"
                (click)="!exportandoCsv && exportarCsv(item)"
              ></i-feather>
              <i-feather
                [ngbTooltip]="podeCancelar(item) ? 'Cancelar' : 'Comando não pode mais ser cancelado'"
                name="x-circle"
                [style.color]="podeCancelar(item) ? 'red' : '#c9c9c9'"
                [style.cursor]="podeCancelar(item) ? 'pointer' : 'not-allowed'"
                (click)="cancelarBatchCommand(item)"
              ></i-feather>
            </td>
          </tr>
          <tr *ngIf="!carregandoLista && batchCommands.length === 0">
            <td colspan="9" class="text-center">
              Nenhum registro encontrado.
            </td>
          </tr>
          <tr *ngIf="carregandoLista">
            <td colspan="9" class="text-center">
              <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="d-flex justify-content-between align-items-center mt-2"
      *ngIf="totalRegistros > 0"
    >
      <small class="text-muted">
        Página {{ paginaAtual }} de {{ totalPaginas }} ({{ totalRegistros }} registro(s))
      </small>
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="carregandoLista || paginaAtual <= 1">
          <button
            type="button"
            class="page-link"
            (click)="paginaAnterior()"
          >
            Anterior
          </button>
        </li>
        <li
          class="page-item"
          [class.disabled]="carregandoLista || !temProximaPagina"
        >
          <button
            type="button"
            class="page-link"
            (click)="proximaPagina()"
          >
            Próxima
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>


<!-- Dialog Novo Comando -->
<ng-template #modalNovoComando let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Novo comando</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group" *ngIf="commandInfoType.length > 0">
      <ng-select
        class="w-100 mb-3"
        placeholder="Selecione um comando"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="commandModalSelect.nome"
        (click)="filterCommandModal(commandModalSelect.nome)"
      >
        <ng-option *ngFor="let command of commandInfoType">
          {{ command.nome }}
        </ng-option>
      </ng-select>
    </div>

    <div *ngIf="commandModalSelect.observacaoHTML != ''">
      <span
        class="card batch-command-description font-weight-bold p-2 d-block"
        [innerHTML]="commandModalSelect.observacaoHTML"
      >
      </span>
    </div>

    <div *ngIf="commandModalSelect.valor" class="form-group mt-2">
      <label class="form-label">Parâmetros</label>
      <input
        class="form-control"
        [placeholder]="commandModalSelect.exemplo"
        [(ngModel)]="commandModalSelect.param"
      />
    </div>

    <div class="row mt-2">
      <div class="col-md-6">
        <label class="form-label">Timeout</label>
        <select class="form-select" [(ngModel)]="commandModalSelect.timeout">
          <option *ngFor="let item of timeOutKeys; let i = index" [value]="i">
            {{ item }}
          </option>
        </select>
      </div>
    </div>

    <div class="mt-3">
      <button
        class="btn btn-success"
        type="button"
        (click)="incluirComando(modal)"
        [disabled]="
          (commandModalSelect.valor && commandModalSelect.param.length < 1) ||
          commandModalSelect.nome == 'Selecione um comando' ||
          commandModalSelect.nome == ''
        "
      >
        Incluir
      </button>
    </div>
  </div>
</ng-template>
<!-- Fim Dialog Novo Comando -->

<!-- Dialog Detalhes do Comando em Lote -->
<ng-template #modalDetalhesComando let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Detalhes do comando em lote</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="text-center" *ngIf="carregandoDetalhe && !detalheComando">
      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
    </div>

    <p class="text-danger" *ngIf="erroDetalhe">{{ erroDetalhe }}</p>

    <ng-container *ngIf="detalheComando">
      <table class="table table-sm table-borderless mb-3">
        <tbody>
          <tr>
            <th>Nome</th>
            <td>{{ detalheComando.nome }}</td>
            <th>Tipo de envio</th>
            <td>{{ detalheComando.tipoEnvio }}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{{ detalheComando.status }}</td>
            <th>Quantidade</th>
            <td>{{ detalheComando.quantidade }}</td>
          </tr>
          <tr>
            <th>Comando</th>
            <td>{{ detalheComando.nomeComando }}</td>
            <th>Parâmetro</th>
            <td class="text-break">{{ detalheComando.parametroComando }}</td>
          </tr>
          <tr>
            <th>Timeout</th>
            <td>{{ detalheComando.timeout }}</td>
            <th></th>
            <td></td>
          </tr>
          <tr *ngIf="detalheComando.equipamento || detalheComando.firmware">
            <th>Equipamento</th>
            <td>{{ detalheComando.equipamento }}</td>
            <th>Firmware</th>
            <td>{{ detalheComando.firmware }}</td>
          </tr>
          <tr>
            <th>Data</th>
            <td>{{ detalheComando.createTime | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <th>Última atualização</th>
            <td>{{ detalheComando.updateTime | date:'dd/MM/yyyy HH:mm:ss' }}</td>
          </tr>
        </tbody>
      </table>

      <h6 class="card-title">Agendamento</h6>
      <p class="text-muted" *ngIf="!detalheComando.agendamento || detalheComando.agendamento.length === 0">
        Executar a qualquer momento
      </p>
      <ul class="list-group mb-3" *ngIf="detalheComando.agendamento && detalheComando.agendamento.length > 0">
        <li class="list-group-item" *ngFor="let agendamento of detalheComando.agendamento">
          {{ labelDiaSemana(agendamento.diaSemana) }} das {{ agendamento.horaInicio }} às {{ agendamento.horaFim }}
        </li>
      </ul>

      <h6 class="card-title">Totalizador de comandos</h6>
      <div class="table-responsive mb-3" *ngIf="detalheComando.totalizadorComandos">
        <table class="table table-bordered table-sm text-center">
          <thead class="table-light">
            <tr>
              <th>Pendente</th>
              <th>Enviando</th>
              <th>Executado</th>
              <th>Cancelado</th>
              <th>Timeout</th>
              <th>Erro de execução</th>
              <th>Não encontrado</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ detalheComando.totalizadorComandos.pendente }}</td>
              <td>{{ detalheComando.totalizadorComandos.enviando }}</td>
              <td>{{ detalheComando.totalizadorComandos.executado }}</td>
              <td>{{ detalheComando.totalizadorComandos.cancelado }}</td>
              <td>{{ detalheComando.totalizadorComandos.timeout }}</td>
              <td>{{ detalheComando.totalizadorComandos.erroExecucao }}</td>
              <td>{{ detalheComando.totalizadorComandos.naoEncontrado }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h6 class="card-title">Seriais</h6>

      <div class="table-responsive">
        <table class="table table-bordered table-sm table-hover">
          <thead class="table-light">
            <tr>
              <th>Serial</th>
              <th>Status</th>
              <th>Data de criação</th>
              <th>Última atualização</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let serial of detalheComando.seriais">
              <td>{{ serial.serial }}</td>
              <td>{{ serial.status }}</td>
              <td>{{ serial.createTime | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ serial.updateTime | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            </tr>
            <tr *ngIf="!carregandoDetalhe && detalheComando.seriais.length === 0">
              <td colspan="4" class="text-center">Nenhum serial encontrado.</td>
            </tr>
            <tr *ngIf="carregandoDetalhe">
              <td colspan="4" class="text-center">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="d-flex justify-content-between align-items-center mt-2"
        *ngIf="detalheComando.total > 0"
      >
        <small class="text-muted">
          Página {{ paginaSeriais }} de {{ totalPaginasSeriais }} ({{ detalheComando.total }} serial(is))
        </small>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="carregandoDetalhe || paginaSeriais <= 1">
            <button
              type="button"
              class="page-link"
              (click)="paginaAnteriorSeriais()"
            >
              Anterior
            </button>
          </li>
          <li
            class="page-item"
            [class.disabled]="carregandoDetalhe || paginaSeriais >= totalPaginasSeriais"
          >
            <button
              type="button"
              class="page-link"
              (click)="proximaPaginaSeriais()"
            >
              Próxima
            </button>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</ng-template>
<!-- Fim Dialog Detalhes do Comando em Lote -->
